__turbopack_context__.v({
  "icon": "styles-module__03o2Tq__icon",
  "link": "styles-module__03o2Tq__link",
  "wrapper": "styles-module__03o2Tq__wrapper",
});
